import {
    FETCH_TASKS,
    FETCH_PRODUCTS,
    OPEN_MODAL,
    APPROVE_USER,
    APPROVE_DOCUMENT,
    REJECT_DOCUMENT,
    DOWNLOAD_ALL_CUSTOMER_INFORMATION,
    DOWNLOAD_TASKS_HISTORY,
    DOWNLOAD_USER_BEHAVIOR,
    DOWNLOAD_DOCUMENT_ACCESS
} from "./actions.type";
import {
    QUERY_CHANGED,
    USER_TASKS_FETCHED,
    REFRESH_MODAL,
    PERMISSIONS_FETCHED,
    PERMISSION_CHANGED,
    PRODUCTS_FETCHED,
    PRODUCTS_CHANGED,
    COMMENT_CHANGED,
    NO_ITEMS_FOUND,
} from "./mutations.type";
import  {TasksService, UserService} from "../common/api.service";
import {simpleFileDownload} from "../common/download.service";
import API_URL from "../common/config";

export function getInitialState() {
    return {
        tasks: [],
        results: 0,
        query: {
            q: "",
            sort: "",
            order: "",
            status: "",
            page: 0,
            pageSize: 10,
        },
        permissions: {
            averageUserGroup: {},
            privilegedUserGroup: {}
        },
		documentPermissions: {
			selectedUsers: [],
			userGroups: []
		},
        productOptions: [],
        formData: {
            taskId: "",
            requestor: "",
            documentId: "",
            products: [],
            comment: ""
        },
        refreshModalToggle: false,
        latestPermissionChange: {} // For dynamic watching for users in multiple TreeMenus
    }
}

const state = getInitialState();

const getters = {
    tasks(state) {
        return state.tasks;
    },
    results(state) {
        return state.results;
    },
    page(state) {
        return state.query.page + 1;
    },
    taskId(state) {
        return state.formData.taskId;
    },
    requestor(state) {
        return state.formData.requestor;
    },
    documentId(state) {
        return state.formData.documentId;
    },
    productOptions(state) {
        return state.productOptions;
    },
    currentProducts(state) {
        return state.formData.products;
    },
    latestPermissionChange(state) {
        return state.latestPermissionChange;
    },
    refreshModalToggle(state) {
        return state.refreshModalToggle;
    },
	selectedUsers(state) {
    	return state.permissions.selectedUsers;
	},
	userGroups(state) {
		return state.permissions.userGroups;
	},
	permissions(state) {
    	return state.permissions;
	}
};

const actions = {
    [FETCH_TASKS]({commit, state}) {
        return TasksService.getTasks(state.query)
            .then(response => {
                commit(USER_TASKS_FETCHED, response);
            })
            .catch(error => {
                commit(NO_ITEMS_FOUND);
                throw new Error(error);
            });
    },
    [FETCH_PRODUCTS]({commit, state}, payload) {
        return TasksService.getProducts(payload)
            .then(({data}) => {
                commit(PRODUCTS_FETCHED, {queryProducts: data.items});
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [OPEN_MODAL]({commit, state}, payload) {
        commit(REFRESH_MODAL, payload);

        if (payload.taskType === 'User Registration') {
            return TasksService.getUserGroups({email: payload.requestor})
                .then(({data}) => {
                    commit(PERMISSIONS_FETCHED, data);
                });
        }
        if (payload.taskType === 'Document approval') {
            return TasksService.getDocumentGroups({documentId: payload.documentId})
                .then(({data}) => {
                    commit(PERMISSIONS_FETCHED, data);
                    return TasksService.getProductsForDocument({documentId: payload.documentId})
                        .then(({data}) => {
                            if(typeof(data) !== 'undefined') {
                                commit(PRODUCTS_FETCHED, {documentProducts: data.items});
                            }
                        });
                });
        }
    },
    [APPROVE_USER]({state}) {
        return UserService.approveUser({taskId: state.formData.taskId, groups: state.permissions.selectedUsers})
            .catch(error => {
                throw new Error(error)
            });
    },
    [REJECT_DOCUMENT]({state}) {
        return TasksService.rejectDocument(state.formData.taskId, state.formData.comment)
            .catch(error => {
                throw new Error(error)
            });
    },
    [APPROVE_DOCUMENT]({state}) {
        return TasksService.approveDocument(state.formData.taskId, {
            groups: state.permissions.selectedUsers,
            products: state.formData.products.map(product => product.value)
        })
            .catch(error => {
                throw new Error(error)
            });
    },
    [DOWNLOAD_ALL_CUSTOMER_INFORMATION]() {
        simpleFileDownload(API_URL+ "user-management/v1/excel/users");
    },
    [DOWNLOAD_TASKS_HISTORY]() {
        simpleFileDownload(API_URL+ "tasks/v1/excel/tasks");
    },
    [DOWNLOAD_USER_BEHAVIOR]() {
        simpleFileDownload(API_URL+ "user-management/v1/excel/analytics");
    },
    [DOWNLOAD_DOCUMENT_ACCESS]() {
        simpleFileDownload(API_URL + "user-management/v1/excel/secure-documents");
    },
};

const mutations = {
    [QUERY_CHANGED](state, payload) {
        state.query = {...state.query, ...payload};
    },
    [USER_TASKS_FETCHED](state, response) {
        let tasks = response.data.items;
        // Sanitize the payload
        tasks.forEach(task => {
            if (task.type === "DOCUMENT_APPROVAL") {
                task.type = 'Document approval';
            }
            if (task.type === "USER_REGISTRATION") {
                task.type = 'User Registration';
            }
            task.date = new Date(task.date);

            switch (task.status) {
                case 'Created':
                    task.status = 'Pending';
                    task['action'] = 'Review';
                    break;
                case 'Resolved':
                    task.status = 'Reviewed';
                    task['action'] = 'Change';
                    break;
                case 'Failed':
                    task.status = 'Rejected';
                    break;
            }
        });
        state.tasks = Object.assign([], tasks);
        state.results = response.data.results;
    },
    [REFRESH_MODAL](state, {taskId, taskType, requestor, documentId}) {
        state.refreshModalToggle = !state.refreshModalToggle;
        state.formData = {
            taskId: taskId,
            products: [],
            comment: ""
        };
        state.permissions = {
        	selectedUsers: [],
			userGroups: []
		};
        state.productOptions = [];
        if (taskType === 'User Registration') {
            state.formData.requestor = requestor;
            state.formData.documentId = "";
        }
        if (taskType === 'Document approval') {
            state.formData.requestor = "";
            state.formData.documentId = documentId;
        }
    },
    [PERMISSION_CHANGED](state, {value, name}) {
        if (value) {
            if (state.permissions.selectedUsers.indexOf(name) === -1) {
                state.permissions.selectedUsers.push(name);
            }
        } else {
            let index = state.permissions.selectedUsers.indexOf(name);
            if (index > -1) {
                state.permissions.selectedUsers.splice(index, 1);
            }
        }
        state.latestPermissionChange = {value: value, name: name};
    },
    [PERMISSIONS_FETCHED](state, payload) {
		state.permissions.selectedUsers = payload.selectedUsers;
		state.permissions.userGroups = payload.userGroups;
    },
    [PRODUCTS_CHANGED](state, payload) {
        state.formData.products = payload;
    },
    [PRODUCTS_FETCHED](state, payload) {
        if (payload.documentProducts) {
            parseProducts(payload.documentProducts);
            state.formData.products = payload.documentProducts;
        }
        if (payload.queryProducts) {
            parseProducts(payload.queryProducts);
            state.productOptions = payload.queryProducts;
        }
    },
    [COMMENT_CHANGED](state, payload) {
        state.formData.comment = payload;
    },
    [NO_ITEMS_FOUND](state) {
        state.tasks = [];
        state.results = 0;
    },
};

function parseProducts(products) {
    products.forEach(object => {
        Object.defineProperty(object, 'value', Object.getOwnPropertyDescriptor(object, 'productId'));
        delete object['productId'];
        Object.defineProperty(object, 'text', Object.getOwnPropertyDescriptor(object, 'productName'));
        delete object['productName'];
    });
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

